import axios from '@/plugins/axios';
import qs from 'qs';
import utils from '@/stores/utils';

const { getStorageKey, loadFiltersFromStorage, saveFiltersToStorage } = utils;

const DEFAULT_FILTERS = { offset: 0, limit: 20, ordering: "name" };

const state = {
    prospects: [],
    filters: DEFAULT_FILTERS,
    prospects_loading: false,
    prospects_count: 0,
    prospects_loading_errors: null,
    prospects_cancel_source: null,
    synchronizing_prospects: false,
    synchronizing_prospects_errors: null,
};

const mutations = {
    updateFilters(state, filters) {
        state.filters = filters;
        saveFiltersToStorage(getStorageKey('radar', 'default'), state.filters);
    },
    updateProspects(state, prospects) {
        state.prospects = prospects;
    },
    updateProspectsCount(state, prospects_count) {
        state.prospects_count = prospects_count;
    },
    updateProspectsLoading(state, loading) {
        state.prospects_loading = loading;
    },
    updateProspectsLoadingErrors(state, errors) {
        state.prospects_loading_errors = errors;
    },
    updateSynchronizingProspects(state, synchronizing) {
        state.synchronize_prospects = synchronizing;
    },
    updateSynchronizingProspectsErrors(state, errors) {
        state.synchronizing_prospects_errors = errors;
    },
    updateProspectsCancelSource(state, cancel_source) {
        state.prospects_cancel_source = cancel_source;
    },
};

const actions = {

    async deleteProspect({ commit, dispatch, state }, prospect) {

        try {
            commit('updateProspectsLoading', true);
            commit('updateProspectsLoadingErrors', null);

            const response = await axios.delete(`/api/prospects/${prospect.id}/`);
            commit('updateProspectsLoading', false);
            dispatch('fetchProspects');
            return response;
        }
        catch (xhr_error) {
            let error = utils.handleError(xhr_error);
            commit('updateProspectsLoadingErrors', error.details);
            commit('updateProspectsLoading', false);
            throw error;
        }
    },


    async fetchProspects({ commit, dispatch, state }, params) {
        commit('updateProspectsLoading', true);
        commit('updateProspectsLoadingErrors', null);

        if (state.prospects_cancel_source) {
            state.prospects_cancel_source.cancel("canceled");
        }

        const filters = loadFiltersFromStorage(getStorageKey('radar', 'default'), DEFAULT_FILTERS);
        commit('updateFilters', filters);

        const cancelSource = axios.CancelToken.source();
        commit('updateProspectsCancelSource', cancelSource);

        try {
            const response = await axios.get('/api/prospects/', {
                params: { ...state.filters },
                cancelToken: state.prospects_cancel_source?.token
            });
            commit('updateProspectsLoading', false);
            commit('updateProspects', response.data.results);
            commit('updateProspectsCount', response.data.count);
            commit('updateProspectsCancelSource', null);
            return response;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            let error = utils.handleError(xhr_error);
            commit('updateProspectsLoadingErrors', error.details);
            commit('updateProspectsLoading', false);
            throw error;
        }
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
